import { literal, number, string, TypeOf } from 'zod';

import { BaseProduct } from './base';
import { ProductType } from './types';

/* ----------------------------- Episode Product ---------------------------- */

export const EpisodeProduct = BaseProduct.extend({
    type: literal(ProductType.Episode),
    showId: string().optional(),
    seasonId: string().optional(),
    episodeNumber: string()
        .or(number())
        .transform((episodeNumber) =>
            typeof episodeNumber === 'string'
                ? episodeNumber
                : String(episodeNumber),
        )
        .optional(),
});
export type EpisodeProduct = TypeOf<typeof EpisodeProduct>;
